import { ActionTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

export interface CommissioningActionType {
  value: ActionTypeEnum;
  displayName: string;
  comment: string;
}

export const CommissioningGasActionTypeEnum: CommissioningActionType[] = [
  {
    value: ActionTypeEnum.commissioning,
    displayName: 'Zähler einbauen / Neuanschluss',
    comment: 'Sie möchten einen Zähler einbauen.'
  },
  //{
  //  value: ActionTypeEnum.change,
  //  displayName: 'Zähler wechseln',
  //  comment: 'Sie möchten einen Zähler wechseln.'
  //},
  {
    value: ActionTypeEnum.decommissioning,
    displayName: 'Außerbetriebnahme',
    comment: 'Sie möchten einen Zähler außer Betrieb setzen.'
  },
  {
    value: ActionTypeEnum.changeCommunicate,
    displayName: 'Änderung mitteilen / Anlagenerweiterung / Gerätetausch',
    comment:
      'Sie wollen uns eine Änderung der Anlage mitteilen, wie z.B: eine Erweiterung oder eine Leistungsreduzierung.'
  },
  {
    value: ActionTypeEnum.recommissioning,
    displayName: 'Wiederinbetriebnahme',
    comment: 'Sie wollen eine Anlage wieder in Betrieb nehmen?'
  },
  {
    value: ActionTypeEnum.temporaryRecommissioning,
    displayName: 'kurzfristige Wiederinbetriebnahme',
    comment:
      'Sie wollen einen Anschluss, der nur kurzzeitig außer Betrieb genommen wurde (z. B. nach einer Anschlusstrennung), wieder in Betrieb nehmen.'
  }
];

export const CommissioningPowerActionTypeEnum: CommissioningActionType[] = [
  {
    value: ActionTypeEnum.commissioning,
    displayName: 'Zähler einbauen',
    comment: 'Sie möchten einen Zähler einbauen.'
  },
  {
    value: ActionTypeEnum.decommissioning,
    displayName: 'Zähler demontieren',
    comment: 'Sie möchten einen Zähler demontieren.'
  },
  {
    value: ActionTypeEnum.change,
    displayName: 'Zähler wechseln',
    comment: 'Sie möchten einen Zähler wechseln.'
  },
  {
    value: ActionTypeEnum.sealing,
    displayName: 'Anlage plombieren',
    comment: 'Sie möchten, dass wir eine Anlage (Hausanschlusskasten oder Zähler...) neu plombieren.'
  },
  {
    value: ActionTypeEnum.changeCommunicate,
    displayName: 'Änderung mitteilen',
    comment:
      'Sie wollen uns eine Änderung an einem Netzanschluss mitteilen für die kein Zählerwechsel benötigt wird.\n' +
      'z.B. Inbetriebnahme einer Ladeeinrichtung unter 12kW'
  },
  {
    value: ActionTypeEnum.tariffControlInstall,
    displayName: 'Steuergerät einbauen',
    comment: 'Sie möchten einen Steuergerät einbauen'
  },
  {
    value: ActionTypeEnum.tariffControlRemove,
    displayName: 'Steuergerät ausbauen',
    comment: 'Sie möchten einen Steuergerät ausbauen'
  },
  {
    value: ActionTypeEnum.tariffControlChange,
    displayName: 'Steuergerät wechseln',
    comment: 'Sie wollen uns eine Änderung an einer Steuergerät mitteilen'
  },
  {
    value: ActionTypeEnum.recommissioning,
    displayName: 'Wiederinbetriebnahme',
    comment: 'Sie wollen eine Anlage wieder in Betrieb nehmen?'
  },
  {
    value: ActionTypeEnum.temporaryPower,
    displayName: 'Baustromanschluss',
    comment: 'Sie wollen einen Baustromzähler beantragen?'
  }
];

export const CommissioningWaterActionTypeEnum: CommissioningActionType[] = [
  {
    value: ActionTypeEnum.commissioning,
    displayName: 'Zähler einbauen / Neuanschluss',
    comment: 'Sie möchten einen Zähler einbauen.'
  },
  {
    value: ActionTypeEnum.change,
    displayName: 'Zähler wechseln',
    comment: 'Sie möchten einen Zähler wechseln.'
  },
  {
    value: ActionTypeEnum.decommissioning,
    displayName: 'Außerbetriebnahme',
    comment: 'Sie möchten einen Zähler außer Betrieb setzen.'
  },
  {
    value: ActionTypeEnum.changeCommunicate,
    displayName: 'Änderung mitteilen / Anlagenerweiterung',
    comment:
      'Sie wollen uns eine Änderung der Anlage mitteilen, wie z.B: eine Erweiterung oder eine Leistungsreduzierung.'
  },
  {
    value: ActionTypeEnum.recommissioning,
    displayName: 'Wiederinbetriebnahme',
    comment: 'Sie wollen eine Anlage wieder in Betrieb nehmen?'
  }
];

export const CommissioningDistrictHeatActionTypeEnum = [
  {
    value: ActionTypeEnum.commissioning,
    displayName: 'Zähler Einbau / Inbetriebnahme',
    comment: 'Sie möchten einen Zähler einbauen.'
  },
  //{
  //  value: ActionTypeEnum.change,
  //  displayName: 'Zähler wechseln',
  //  comment: 'Sie möchten einen Zähler wechseln.'
  //},
  {
    value: ActionTypeEnum.changeCommunicate,
    displayName: 'Änderung mitteilen',
    comment: 'Sie wollen uns eine Änderung der Anlage mitteilen für die kein Zählerwechsel benötigt wird.'
  }
  //{
  //  value: ActionTypeEnum.decommissioning,
  //  displayName: 'Außerbetriebnahme',
  //  comment: 'Sie möchten einen Zähler außer Betrieb setzen.'
  //}
];

export const CommissioningPowerMeterTypeConstant = [
  {
    value: 'AlternatingMeter',
    displayName: 'Wechselstromzähler'
  },
  {
    value: 'ThreePhaseMeter',
    displayName: 'Drehstromzähler'
  },
  {
    value: 'MultyTariffMeter', // Todo: Schreibfehler, muss erst im Backend und wahrscheinlich auch in der Datenbank korrigiert werden
    displayName: 'Mehrtarifzähler'
  },
  {
    value: 'LoadMeter',
    displayName: 'Lastgangzähler'
  },
  {
    value: 'BidirectionalMeter',
    displayName: 'Zweirichtungszähler'
  },
  {
    value: 'TransformerMeter',
    displayName: 'Wandlerzähler'
  },
  {
    value: 'MaximunRateMeter', // Todo: Schreibfehler, muss erst im Backend und wahrscheinlich auch in der Datenbank korrigiert werden
    displayName: 'Maximumzähler'
  },
  {
    value: 'PrepaidMeter',
    displayName: 'Prepaid Zähler'
  },
  {
    value: 'MultiTariffBidirectional',
    displayName: 'Mehrtarif-Zweirichtungszähler'
  },
  {
    value: 'iMSys',
    displayName: 'intelligentes Messsystem (iMSys)'
  },
  {
    value: 'AlternatingMeterBidirectional',
    displayName: 'Wechselstromzähler-Zweirichtung'
  },
  {
    value: 'ThreePhaseMeterBidirectional',
    displayName: 'Drehstromzähler-Zweirichtung'
  },
  {
    value: 'PartialIndirectMetering',
    displayName: 'halbindirekte Messung'
  },
  {
    value: 'PartialIndirectMeteringTemporary',
    displayName: 'halbindirekte Messung (Baustrom)'
  },
  {
    value: 'PartialIndirectMeteringBidirectional',
    displayName: 'halbindirekte Messung-Zweirichtung'
  },
  {
    value: 'PartialIndirectMeteringRLM',
    displayName: 'halbindirekte Messung (RLM)'
  },
  {
    value: 'PartialIndirectMeteringRLMTemporary',
    displayName: 'halbindirekte Messung (RLM, Baustrom)'
  },
  {
    value: 'PartialIndirectMeteringBidirectionalRLM',
    displayName: 'halbindirekte Messung-Zweirichtung (RLM)'
  },
  {
    value: 'IndirectMetering',
    displayName: 'indirekte Messung'
  },
  {
    value: 'IndirectMeteringBidirectional',
    displayName: 'indirekte Messung-Zweirichtung'
  }
];

export const CommissioningListFilterTypeConstant: { value: ActionTypeEnum; displayName: string }[] = [
  { value: ActionTypeEnum.commissioning, displayName: 'Inbetriebnahme / Einbau' },
  { value: ActionTypeEnum.change, displayName: 'Wechsel' },
  { value: ActionTypeEnum.decommissioning, displayName: 'Außerbetriebnahme' },
  { value: ActionTypeEnum.changeCommunicate, displayName: 'Änderung mitteilen' },
  { value: ActionTypeEnum.recommissioning, displayName: 'Wiederinbetriebnahme' },
  { value: ActionTypeEnum.temporaryRecommissioning, displayName: 'Kurzfristige Wiederinbetriebnahme' },
  { value: ActionTypeEnum.sealing, displayName: 'Plombierung' },
  { value: ActionTypeEnum.tariffControlInstall, displayName: 'Steuergerät einbauen' },
  { value: ActionTypeEnum.tariffControlRemove, displayName: 'Steuergerät ausbauen' },
  { value: ActionTypeEnum.tariffControlChange, displayName: 'Steuergerät wechseln' },
  { value: ActionTypeEnum.temporaryPower, displayName: 'Baustromanschluss' }
];
